import{getAlgoliaSearchClient as t}from"./get-algolia-search-client.js";const e=t=>({getSearchClient:()=>t}),r=r=>{const o=t(r);return e(o)};export{e as buildAlgoliaService,r as getAlgoliaService};
